import { Card, Checkbox, Divider, message, Space, Spin, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";
import DateRangeSelect from "../../../components/DateRangeSelect";

function CampusesStats() {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);
  const [ativeKey, setActiveKey] = useState("revenue");
  const [selectedRange, setSelectedRange] = useState([
    moment().startOf("days"),
    moment().endOf("days"),
  ]);

  const getStats = async (dates) => {
    setLoading(true);
    let startDate = moment(dates[0]).toString();
    let endDate = moment(dates[1]).toString();
    const res = await apiRequest({
      path:
        apiPaths.stats +
        `/campuses?start_date=${startDate}&end_date=${endDate}`,
    });
    setLoading(false);
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    setStats(res);
  };

  useEffect(() => {
    getStats(selectedRange);
  }, [selectedRange]);

  const COLORS = [
    "#FFBB28",
    "#f01ff6",
    "#FF0000",
    "#ee550a",
    "#55320a",
    "#FFaa0a",
    "#B7c8a2",
    "#FF8042",
    "#001256",
  ];

  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
    value,
    ...props
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <>
        <text {...props}>
          {ativeKey !== "count" ? "₹" + value : value + " rides"}
        </text>
        ;
        <text
          x={x}
          y={y}
          fill="white"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
        >
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      </>
    );
  };

  const data = stats.campuses || [];

  const PIECHART_TYPES = [
    { key: "upi_revenue", label: "UPI Rides Collection" },
    { key: "revenue", label: "Wallet Rides Collection" },
    { key: "count", label: "Ride Count" },
    { key: "amount", label: "Wallet Collection" },
  ];

  return (
    <div>
      <Divider />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 15,
        }}
      >
        <div>
          <div style={{ fontSize: 20 }}>Campuses Stats</div>
          <div style={{ color: "#b7b7b7" }}>
            Note: Below stats is for the selected date range
          </div>
        </div>
        <div style={{ marginRight: 10 }}>
          <DateRangeSelect
            selectedRange={selectedRange}
            onSelectedRangeChanged={setSelectedRange}
          />
        </div>
      </div>
      <div style={{ marginBottom: 25, minHeight: 300 }}>
        {loading ? (
          <div>
            <Spin /> Loading stats...
          </div>
        ) : (
          <div>
            <div
              className="stats-container"
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-evenly",
              }}
            >
              <div id="table">
                <Table
                  dataSource={data}
                  pagination={false}
                  columns={[
                    {
                      title: "Campus",
                      dataIndex: "name",
                    },
                    {
                      title: "Rides",
                      children: [
                        {
                          title: "Pass",
                          dataIndex: "ride_with_plan",
                          key: "ride_with_plan",
                        },
                        {
                          title: "Wallet",
                          dataIndex: "ride_without_plan",
                          key: "ride_without_plan",
                        },
                        {
                          title: "UPI",
                          dataIndex: "ride_with_upi",
                          key: "ride_with_upi",
                        },
                      ],
                    },
                    {
                      title: "Wallet Collection",
                      dataIndex: "amount",
                      render: (value, row) => {
                        return "₹ " + value;
                      },
                    },
                    {
                      title: "Ride Collection",
                      children: [
                        {
                          title: "UPI",
                          dataIndex: "upi_revenue",
                          key: "upi_revenue",
                          render: (value) => {
                            return "₹ " + value;
                          },
                        },
                        {
                          title: "Wallet",
                          dataIndex: "revenue",
                          key: "revenue",
                          render: (value) => {
                            return "₹ " + value;
                          },
                        },
                      ],
                    },
                  ]}
                  size="small"
                />
              </div>
              <div id="chart">
                <Card style={{ width: "100%" }}>
                  <div style={{ color: "#a7a7a7", marginBottom: 5 }}>
                    Difference in %
                    <span style={{ fontSize: 11 }}>
                      {" ( Show the chart for selected checkbox )"}
                    </span>
                  </div>
                  <Space direction="horizontal">
                    {PIECHART_TYPES.map((item, idx) => (
                      <Checkbox
                        key={idx}
                        checked={ativeKey === item.key}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setActiveKey(item.key);
                          }
                        }}
                      >
                        {`By ${item.label}`}
                      </Checkbox>
                    ))}
                  </Space>
                  <div
                    style={{
                      width: "100%",
                      height: 300,
                      position: "relative",
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart width={400} height={400}>
                        <Pie
                          data={data}
                          cx="50%"
                          cy="50%"
                          // labelLine={false}
                          label={renderCustomizedLabel}
                          outerRadius={80}
                          fill="#8884d8"
                          dataKey={ativeKey}
                        >
                          {data.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                    }}
                  >
                    {data.map((item, idx) => (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                        key={idx}
                      >
                        <div
                          style={{
                            width: 5,
                            height: 5,
                            marginRight: 5,
                            backgroundColor: COLORS[idx],
                          }}
                        />
                        <div>{item.name}</div>
                      </div>
                    ))}
                  </div>
                </Card>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CampusesStats;
